import { AbstractControl, ValidatorFn } from '@angular/forms';

export const isNumber: ValidatorFn = (control: AbstractControl) => {
  const number: boolean = !isNaN(Number.parseFloat(control.value));

  return number ? null : { isNumber: false };
};
